import { FunctionComponent } from "react";

import { ProfileTrackerTable } from "../../components/ProfileTrackerTable";

export const TrackerOverview: FunctionComponent = () => {
	return (
		<div className="sm:block flex flex-col items-start justify-between">
			<div className="flex items-end justify-between w-full mb-[16px]">
				<div className="flex-grow">
					<h3 className="mb-3 text-md font-semibold leading-6">Custom Signal Tracker</h3>
				</div>
			</div>

			{<ProfileTrackerTable />}
		</div>
	);
};
